// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import BookmarkUpdateController from "./bookmark_update_controller";
application.register("bookmark-update", BookmarkUpdateController);

import CopyLinkController from "./copy_link_controller";
application.register("copy-link", CopyLinkController);

import HeaderController from "./header_controller";
application.register("header", HeaderController);

import HomeScreenGuideController from "./home_screen_guide_controller";
application.register("home-screen-guide", HomeScreenGuideController);

import LinkController from "./link_controller";
application.register("link", LinkController);

import ReviewModalController from "./review_modal_controller";
application.register("review-modal", ReviewModalController);

import SearchResultsTrackingController from "./search_results_tracking_controller";
application.register("search-results-tracking", SearchResultsTrackingController);

import ToastrController from "./toastr_controller";
application.register("toastr", ToastrController);

import SellerProfileFormController from "./seller_profile_form_controller";
application.register("seller-profile-form", SellerProfileFormController);
import TweetRecommendController from "./tweet_recommend_controller";
application.register("tweet-recommend", TweetRecommendController);

import Ga4ServiceRequestController from "./ga4_service_request_controller";
application.register("ga4-service-request", Ga4ServiceRequestController);

import NotificationSettingController from "./notification_setting_controller";
application.register("notification-setting", NotificationSettingController);
